import { render } from "./ViewCollection.vue?vue&type=template&id=41e66962&scoped=true"
import script from "./ViewCollection.vue?vue&type=script&lang=js"
export * from "./ViewCollection.vue?vue&type=script&lang=js"

import "@/Common/Styles/viewCollection.scss?vue&type=style&index=0&id=41e66962&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e66962"]])

export default __exports__